import React from 'react'
import { Edit } from 'react-admin'
import WithDeleteModalToolbar from 'ui-shared/CustomToolbars/WithDeleteModalToolbar'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import VirtualExperiencesForm from './VirtualExperiencesForm'

const VirtualExperienceEdit: React.FC = () => (
  <SectionWrapper>
    <Edit>
      <VirtualExperiencesForm toolbar={<WithDeleteModalToolbar />} />
    </Edit>
  </SectionWrapper>
)

export default VirtualExperienceEdit
